// import React from "react";
// import TeamHeader from "../Components/TeamsComponents/TeamHeader/TeamHeader";
// import Mission from "../Components/TeamsComponents/Mission/Mission";
// import EdBio from "../Components/TeamsComponents/EdBio/EDBio";
// import TeamMembers from "../Components/TeamsComponents/TeamMember/TeamMembers";
// import PfLeaders from "../Components/TeamsComponents/PfLeaders/PfLeaders";
// const Team =()=>{
//     return(
//         <>
// <TeamHeader/>
// <Mission/>
// <EdBio/>
// <TeamMembers/>
// <PfLeaders/>
//         </>
//     )
// }
// export default Team;
import React from "react";
import TeamHero from "../Components/TeamsComponents/TeamHero/TeamHero";
import FounderSpotlight from "../Components/TeamsComponents/FounderSpotlight/FounderSpotlight";
import TeamOperators from "../Components/TeamsComponents/TeamOperators/TeamOperators";
import TeamAdvisoryCouncil from "../Components/TeamsComponents/TeamAdvisoryCouncil/TeamAdvisoryCouncil";

const Team = () => {
  return (
    <>
      <TeamHero />
      <FounderSpotlight />
      <TeamOperators />
      <TeamAdvisoryCouncil />
    </>
  );
};

export default Team;